import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=16a8a5aa&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=16a8a5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8a5aa",
  null
  
)

export default component.exports